import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';

export default function WhyDareUp() {
    const comparisons = [
        { feature: 'No "What should I post?" anxiety', dareup: true, others: false },
        { feature: 'Lower barrier to entry', dareup: true, others: false },
        { feature: 'Built-in content discovery', dareup: true, others: false },
        { feature: 'Safety-first with curated challenges', dareup: true, others: false },
        { feature: 'Join a community doing the same dare', dareup: true, others: false },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">Why Choose DareUp?</h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                        The better way to create and share video content
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="max-w-4xl mx-auto bg-dark-800 border border-dark-700 rounded-3xl p-8 shadow-xl"
                >
                    {/* Header */}
                    <div className="grid grid-cols-3 gap-4 mb-8 pb-6 border-b border-dark-700">
                        <div className="col-span-1"></div>
                        <div className="text-center">
                            <div className="inline-block px-6 py-2 bg-gradient-to-r from-primary-500 to-secondary-500 text-white rounded-xl font-bold text-lg shadow-lg">
                                DareUp
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="inline-block px-6 py-2 bg-dark-700 text-gray-400 rounded-xl font-bold text-lg">
                                Other Apps
                            </div>
                        </div>
                    </div>

                    {/* Comparison rows */}
                    <div className="space-y-4">
                        {comparisons.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: index * 0.1 }}
                                className="grid grid-cols-3 gap-4 items-center py-4 px-4 bg-dark-900/50 border border-dark-700 rounded-xl"
                            >
                                <div className="text-gray-300 font-medium text-sm sm:text-base">{item.feature}</div>
                                <div className="flex justify-center">
                                    {item.dareup ? (
                                        <div className="w-8 h-8 bg-primary-500/20 border border-primary-500/50 rounded-full flex items-center justify-center">
                                            <Check className="w-5 h-5 text-primary-400" />
                                        </div>
                                    ) : (
                                        <div className="w-8 h-8 bg-red-500/20 border border-red-500/50 rounded-full flex items-center justify-center">
                                            <X className="w-5 h-5 text-red-400" />
                                        </div>
                                    )}
                                </div>
                                <div className="flex justify-center">
                                    {item.others ? (
                                        <div className="w-8 h-8 bg-primary-500/20 border border-primary-500/50 rounded-full flex items-center justify-center">
                                            <Check className="w-5 h-5 text-primary-400" />
                                        </div>
                                    ) : (
                                        <div className="w-8 h-8 bg-red-500/20 border border-red-500/50 rounded-full flex items-center justify-center">
                                            <X className="w-5 h-5 text-red-400" />
                                        </div>
                                    )}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
